const chipsExpiredServices = {
  from: 'Desde',
  to: 'Hasta',
  mandatory: 'Servicios Obligatorios',
  nonMandatory: 'Servicios Opcionales',
};

export default chipsExpiredServices;